import styles from './report-iframe.module.css';
import ScaledIframe from './ScaledIframe';

export const ReportIframe = ({ link }: { link: string }) => {
  return (
    <div className={styles.iframeWrapper}>
      <ScaledIframe src={link} scale={0.86} />
    </div>
  );
};
